import { Link } from "react-router-dom";
import ScrollReveal from "@/components/feature/ScrollReveal";

const services = [
  {
    icon: "ri-shield-keyhole-line",
    title: "Cybersecurity\nConsulting & Auditing",
    desc: "Identify vulnerabilities before they become headlines. Our CREST-accredited style audits & red team exercises ensure full compliance.",
    link: "/services/cybersecurity",
    items: [
      "ISO 27001 / NIST gap analysis",
      "Penetration testing & social engineering",
      "Cybersecurity posture audit & IR planning",
      "24/7 threat monitoring (SOC readiness)",
    ],
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Software Development\n& Engineering",
    desc: "Modern, scalable web and mobile applications. We follow DevSecOps principles from design to deployment.",
    link: "/services/software",
    items: [
      "Custom SaaS & business platforms",
      "Cloud-native (AWS, Azure) & API-first",
      "Legacy modernisation & robust architecture",
      "Full-stack engineering: React, .NET, Python, Go",
    ],
  },
  {
    icon: "ri-customer-service-line",
    title: "Strategic IT\nConsulting & Audit",
    desc: "We align technology with business outcomes. From infrastructure health checks to digital transformation strategy.",
    link: "/services/consulting",
    items: [
      "IT governance & compliance review",
      "Cloud cost optimisation & architecture audit",
      "Vendor selection & contract negotiation",
      "Disaster recovery & business continuity",
    ],
  },
];

export default function ServicesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-white dark:bg-dark-bg">
      <div className="px-4 md:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-3 py-1 rounded-full bg-brand-50 dark:bg-brand-500/10 text-brand-600 dark:text-brand-400 text-xs font-semibold uppercase tracking-wider mb-4">
              What We Do
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3">
              Enterprise IT Services
            </h2>
            <p className="text-sm md:text-base text-gray-500 dark:text-gray-400 max-w-xl mx-auto">
              End-to-end IT capabilities that help enterprises move faster and stay secure.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((s, i) => (
            <ScrollReveal key={s.title} delay={i + 1}>
              <Link
                to={s.link}
                className="group block relative p-6 md:p-8 rounded-2xl bg-gray-50 dark:bg-dark-card border border-gray-100 dark:border-dark-border hover:border-brand-200 dark:hover:border-brand-500/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer h-full"
              >
                <div className="w-12 h-12 rounded-xl bg-brand-50 dark:bg-brand-500/10 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${s.icon} text-xl text-brand-500`} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2 whitespace-pre-line">
                  {s.title}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed mb-5">
                  {s.desc}
                </p>
                <ul className="space-y-2 mb-5">
                  {s.items.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-sm text-gray-500 dark:text-gray-400">
                      <i className="ri-check-line text-brand-500 mt-0.5 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-500 group-hover:text-brand-600 transition-colors">
                  Learn more <i className="ri-arrow-right-line text-xs" />
                </span>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}